import { ChartCard, type ChartCardState } from "../../ChartCard";
import { AuditEventRow } from "../../AuditEventRow";
import { useAuditEvents, type AuditEvent } from "../../../../hooks/useAuditEvents";
import { rangeToWindowHours, type InstanceRange } from "../../../../lib/instanceDetailRange";
import auditStyles from "../../../../pages/AuditTrail.module.css";

type AuditPanelProps = {
  readonly tenantId: string;
  readonly range: InstanceRange;
};

const cardState = (
  status: "loading" | "ready" | "error",
  events: ReadonlyArray<AuditEvent>,
): ChartCardState => {
  if (status === "loading") return "loading";
  if (status === "error") return "error";
  if (events.length === 0) return "empty";
  return "ready";
};

export const AuditPanel = ({ tenantId, range }: AuditPanelProps): JSX.Element => {
  const hours = rangeToWindowHours(range);
  const { status, events, error } = useAuditEvents({ scope: "tenant", tenantId, hours });
  return (
    <ChartCard
      title="Audit events"
      wide
      state={cardState(status, events)}
      emptyText="No audited actions for this instance in this window."
      errorText={error ?? undefined}
    >
      <ul className={auditStyles.list}>
        {events.map((event) => (
          <AuditEventRow key={`${event.tenantId}-${event.eventTime}`} event={event} />
        ))}
      </ul>
    </ChartCard>
  );
};
